var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 1.5009C14.3855 1.28203 14.6454 1.10842 14.9313 0.989964C15.2173 0.871513 15.5238 0.810547 15.8333 0.810547C16.1429 0.810547 16.4493 0.871513 16.7353 0.989964C17.0213 1.10842 17.2811 1.28203 17.5 1.5009C17.7189 1.71977 17.8925 1.97961 18.0109 2.26558C18.1294 2.55154 18.1903 2.85804 18.1903 3.16757C18.1903 3.4771 18.1294 3.7836 18.0109 4.06956C17.8925 4.35553 17.7189 4.61537 17.5 4.83424L6.24999 16.0842L1.66666 17.3342L2.91666 12.7509L14.1667 1.5009Z",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.f814aa3d9c478a7532e56610edbdcbc5.svg";
export { ForwardRef as ReactComponent };